import React from "react"
import { Field, ErrorMessage, getIn } from "formik"
import ErrorPopUp from '../../Shared/ErrorPopUp'
import { AsyncCategorySelect } from '../../Shared/AsyncCategorySelect'
import AsyncBrandSelect from '../../Shared/AsyncBrandSelect'
import AsyncProductSelect from '../../Shared/AsyncProductSelect'
import NumberFormat from 'react-number-format'
import measurementTypes from '../../../_constants/measurementTypes'
import { MdClose } from 'react-icons/md'
import { GoPlus } from 'react-icons/go'
import Fab from '@material-ui/core/Fab'
import { DecimalInput } from 'react-hichestan-numberinput'

const item = { categoryId: '', brandId: '', itemId: '', quantity: 0 }

export default ({ touched, errors, setFieldValue, values, handleBlur }) => (
  <>
    <div className="row display-flex">
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <fieldset className="fieldset">
          <legend>مواد اولیه</legend>
          <table className="table validator-table" style={{ marginBottom: 5 }}>
            <thead>
              <tr>
                <th className="text-center">ردیف</th>
                <th className="text-center">دسته بندی</th>
                <th className="text-center">برند</th>
                <th className="text-center">نام کالا</th>
                <th className="text-center">مقدار مورد نیاز</th>
                {/* <th className="text-center">واحد شمارش</th> */}
              </tr>
            </thead>
            <tbody>
              {values.items && values.items.map((item, index) => (
                <tr key={"p-" + index}>
                  <td>{index + 1}</td>
                  <td>
                    {values.items[index].product && values.items[index].product.category.name}
                  </td>
                  <td>
                    {values.items[index].product && values.items[index].product.brand.name}
                  </td>
                  <td>
                    {values.items[index].product && values.items[index].product.name}
                  </td>
                  <td>
                  {values.items[index].product !== undefined &&
                      <div className="flex-col flex-center">
                        {values.items[index].product.subMeasurementType != undefined &&
                          <span style={{ marginBottom: 10 }}>
                            {(values.items[index].subQuantity) + (values.items[index].product.subMeasurementType !== undefined
                              ? ' (' + measurementTypes.filter(el => el.value === values.items[index].product.subMeasurementType)[0].label + ')'
                              : '')}
                          </span>
                        }
                        <span>
                          {(values.items[index].quantity + (values.items[index].product.measurementType !== undefined
                            ? ' (' + measurementTypes.filter(el => el.value === values.items[index].product.measurementType)[0].label + ')'
                            : ''))}
                        </span>
                      </div>
                    }
                  </td>
                  {/* <td>
                    {values.items[index].product ? measurementTypes.filter(el => el.value === values.items[index].product.measurementType)[0].label : ''}
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </fieldset>
      </div>
    </div>

    {values.lastDescription ?
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <fieldset className="fieldset">
            <legend>توضیحات مدیر تولید</legend>
            <pre className="pre">{values.lastDescription}</pre>
          </fieldset>
        </div>
      </div>
      : ''}
  </>
);